import { render } from "./ActionListItemOther.vue?vue&type=template&id=f806a89a"
import script from "./ActionListItemOther.vue?vue&type=script&lang=ts"
export * from "./ActionListItemOther.vue?vue&type=script&lang=ts"
script.render = render

export default script